import { createDarkTheme } from "../default/Dark";

const TrueIdTheme = createDarkTheme({ colorAccent: "#ff1f37" });
TrueIdTheme.default.logoSize = { width: 3.21, height: 2.4 };
TrueIdTheme.default.headerStyle = {
  ...TrueIdTheme.default.headerStyle,
  backgroundColor: "#120B30",
};
TrueIdTheme.default.navigationBar = {
  ...TrueIdTheme.default.navigationBar,
  backgroundColor: "#2C2C2C",
};
TrueIdTheme.default.separatorColor = "#4A2ABE";
export default TrueIdTheme;
